import authFetch from '../../helpers/requests';
import {AddingOptions} from '../grid-dx/types';
import useGetToken from './useGetToken';

function useAdd(url: string) {
  const token = useGetToken();
  return async (addingOptions: AddingOptions) => {
    try {
      const response = await authFetch(
        `${url}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
          body: JSON.stringify(JSON.stringify(addingOptions.added)),
        },
        token,
      );
      return response;
    } catch (e) {
      return e;
    }
  };
}

export function useAddWithPDF(url: string) {
  const token = useGetToken();
  return async (addingOptions: AddingOptions) => {
    let options = new URLSearchParams();
    options.append('values', JSON.stringify(addingOptions.added));
    var formData = new FormData();
    if (typeof addingOptions.added.files !== 'undefined') {
      formData.append('pdf', addingOptions.added.files[0]);
    }
    try {
      const response = await authFetch(
        `${url}?${options}`,
        {
          method: 'POST',
          body: formData,
        },
        token,
      );
      return response;
    } catch (e) {
      console.error(e); //Que hacemos??
    }
  };
}

export function useAddWithoutBody(url: string) {
  const token = useGetToken();
  return async (addingOptions: AddingOptions) => {
    let options = new URLSearchParams();
    options.append('values', JSON.stringify(addingOptions.added));
    try {
      const response = await authFetch(
        `${url}?${options}`,
        {
          method: 'POST',
        },
        token,
      );
      return response;
    } catch (e) {
      console.error(e); //Que hacemos??
    }
  };
}
export default useAdd;
